module.exports = __webpack_public_path__ + "img/hermes.e0284e94.png";